import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { DocumentHead } from '@/components/layout/DocumentHead';

/**
 * AuthLayout - Layout for authentication pages
 * Includes: SEO, Focus Management, Scroll Restoration
 */
export const AuthLayout: React.FC = () => {
  const location = useLocation();

  // Focus management on route change
  useEffect(() => {
    const authContent = document.getElementById('auth-content');
    if (authContent) {
      authContent.focus();
    }
  }, [location.pathname]);

  // Scroll restoration on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      {/* SEO - Document Head */}
      <DocumentHead />

      <main
        id="auth-content"
        tabIndex={-1}
        className="focus:outline-none w-full"
      >
        <Outlet />
      </main>
    </div>
  );
};
